module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/3/2-1523a6540e8d35326010caf55454654f.jpg";